import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setMessageAction } from "../../actions/messageActions";
import { EXTERNAL_LINK } from "../../helpers/endpoints";
import Loader from "../../helpers/Loader";
import useAxios from "../../hooks/useAxios";

export default function ExternalLinkRedirect({ idMenu }) {
  const dispatch = useDispatch();
  const { request: axiosRequest } = useAxios();
  const [loading, setLoading] = useState(true);

  const mensajeSistema = (message, tipo) => {
    dispatch(
      setMessageAction({
        type: tipo,
        mensaje: message
          ? message
          : "Es este momento no podemos procesar la solicitud. Intente mas tarde",
      })
    );
  };

  const redireccion = async () => {
    setLoading(true);
    try {
      const resp = await axiosRequest({
        url: `${EXTERNAL_LINK}?idMenu=${idMenu}`,
        method: "post",
      });
      window.open(resp);
    } catch (error) {
      mensajeSistema(
        "No se puede realizar la acción en este momento. Intente más tarde.",
        "ERROR"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    redireccion();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return null;
}
